
export const COURSE_NOT_FOUND = "Course not found";